import { ROUTES } from "@lhd/constants";
import { PERMISSION_KEYS } from "@lhd/hooks";

export const RETURN_AFTER_LOGIN_STORAGE_KEY =
  "correlation_diagram_return_after_login";

export const PATH_YEAR_PLACEHOLDER = "{year}";

export const PATH_COMPANY_ID_PLACEHOLDER = "{companyId}";

export const CORRELATION_TOOLTIP_MESSAGES = {
  NOT_PURCHASE: "購入無しのため使用不可",
  NO_PERMISSION: "権限無しのため使用不可",
  DEVELOPMENT: "開発中",
} as const;

export const DIAGRAM_ROUTE_PERMISSION: Record<
  string,
  { path: string; permissionKey: string; usageKey?: string }
> = {
  [ROUTES.ANNUAL_ORG_SUMMARIES]: {
    path: `/${ROUTES.ANNUAL_ORG_SUMMARIES}`,
    permissionKey: ROUTES.ORGS,
    usageKey: "basic_features",
  },
  [ROUTES.WORKERS]: {
    path: `/${ROUTES.WORKERS}`,
    permissionKey: "isContractStatusAccepted",
    usageKey: "basic_features",
  },
  [ROUTES.ORGANIZATION_CHART]: {
    path: `/${ROUTES.ORGANIZATION_CHART}?page=1`,
    permissionKey: ROUTES.ORGANIZATION_CHART,
    usageKey: "basic_features",
  },
  company_info: {
    path: `/${ROUTES.COMPANY_CONFIGURATION}/${PATH_COMPANY_ID_PLACEHOLDER}?tab=registration_information&page_mode=edit`,
    permissionKey: "operation",
    usageKey: "basic_features",
  },
  [ROUTES.CUSTOMER_LIST]: {
    path: `/${ROUTES.CUSTOMER_LIST}`,
    permissionKey: ROUTES.CUSTOMER_LIST,
    usageKey: "basic_features",
  },
  [ROUTES.CUSTOMER_HISTORY_SUMMARIES]: {
    path: `/${ROUTES.CUSTOMER_HISTORY_SUMMARIES}`,
    permissionKey: ROUTES.CUSTOMER_LIST,
    usageKey: "basic_features",
  },
  [ROUTES.APPS]: {
    path: `/${ROUTES.APPS}`,
    permissionKey: ROUTES.APPS,
    usageKey: "basic_features",
  },
  [ROUTES.BIZ_SHEET_SUMMARIES]: {
    path: `/${ROUTES.BIZ_SHEET_SUMMARIES}`,
    permissionKey: ROUTES.APPS,
    usageKey: "basic_features",
  },
  [ROUTES.EVENT_FORMS]: {
    path: `/${ROUTES.EVENT_FORMS}`,
    permissionKey: "canManageEventForms",
    usageKey: "basic_features",
  },
  company_info_general: {
    path: `/${ROUTES.COMPANY_CONFIGURATION}/${PATH_COMPANY_ID_PLACEHOLDER}?tab=general_management_information`,
    permissionKey: "operation",
    usageKey: "basic_features",
  },
  [ROUTES.ORGANIZATION_MANAGEMENT]: {
    path: `/${ROUTES.ORGANIZATION_MANAGEMENT}`,
    permissionKey: ROUTES.ORGANIZATION_MANAGEMENT,
  },
  permissions_app: {
    path: `/${ROUTES.PERMISSIONS_MANAGEMENT}?tab=app_permissions`,
    permissionKey: ROUTES.PERMISSIONS_MANAGEMENT,
    usageKey: "basic_features",
  },
  [ROUTES.APPRAISAL_LIST]: {
    path: `/${ROUTES.APPRAISAL_LIST}`,
    permissionKey: "appraisalAdmin",
    usageKey: "appraisal",
  },
  appraisal_training_overview: {
    path: `/${ROUTES.APPRAISAL_SUMMARIES}`,
    permissionKey: "appraisal",
    usageKey: "appraisal",
  },
  [ROUTES.APPRAISAL_KGI_LIST]: {
    path: `/${ROUTES.APPRAISAL_KGI_LIST}`,
    permissionKey: "appraisalAdmin",
    usageKey: "appraisal",
  },
  [ROUTES.APPRAISAL_SHEET_LIST]: {
    path: `/${ROUTES.APPRAISAL_SHEET_LIST}`,
    permissionKey: "appraisal",
    usageKey: "appraisal",
  },
  [ROUTES.APPRAISAL_SETTING]: {
    path: `/${ROUTES.APPRAISAL_SETTING}`,
    permissionKey: "appraisalAdmin",
    usageKey: "appraisal",
  },
  [ROUTES.Electronic_Learning]: {
    path: `/${ROUTES.Electronic_Learning}`,
    permissionKey: ROUTES.Electronic_Learning,
    usageKey: "e_learning",
  },
  [ROUTES.ELECTRONIC_LEARNING_CHART]: {
    path: `/${ROUTES.ELECTRONIC_LEARNING_CHART}`,
    permissionKey: ROUTES.ELECTRONIC_LEARNING_CHART,
    usageKey: "e_learning",
  },
  elearningStore: {
    path: `/${ROUTES.Electronic_Learning}/${ROUTES.STORE}`,
    permissionKey: "elearningStore",
    usageKey: "e_learning",
  },
  [ROUTES.ANNUAL_SALARY_SUMMARIES]: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
    permissionKey: ROUTES.ANNUAL_SALARY_SUMMARIES,
    usageKey: "salary_management",
  },
  salary_provisions: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${PATH_YEAR_PLACEHOLDER}/${ROUTES.WORKS}`,
    permissionKey: PERMISSION_KEYS.FULL_SALARY,
    usageKey: "salary_management",
  },
  salary_works: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${PATH_YEAR_PLACEHOLDER}/${ROUTES.EXPENSES}`,
    permissionKey: PERMISSION_KEYS.FULL_SALARY,
    usageKey: "salary_management",
  },
  salary_expenses: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${PATH_YEAR_PLACEHOLDER}/${ROUTES.ARRANGEMENTS}`,
    permissionKey: PERMISSION_KEYS.FULL_SALARY,
    usageKey: "salary_management",
  },
  business_trip_reports_approval: {
    path: `/${ROUTES.BUSINESS_TRIP_REPORTS}?view_type=approval&year=${PATH_YEAR_PLACEHOLDER}`,
    permissionKey: PERMISSION_KEYS.FULL_SALARY,
    usageKey: "salary_management",
  },
  salary_arrangements: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${PATH_YEAR_PLACEHOLDER}/${ROUTES.SALARY_SHEETS}`,
    permissionKey: PERMISSION_KEYS.SALARY_VIEW_ONLY,
    usageKey: "salary_management",
  },
  payment_sheets: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${PATH_YEAR_PLACEHOLDER}/${ROUTES.PAYMENT_SHEETS}`,
    permissionKey: PERMISSION_KEYS.SALARY_VIEW_ONLY,
    usageKey: "salary_management",
  },
  [ROUTES.ANNUAL_SALARY_LIST]: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${PATH_YEAR_PLACEHOLDER}/${ROUTES.PROVISIONS}`,
    permissionKey: PERMISSION_KEYS.FULL_SALARY,
    usageKey: "salary_management",
  },
  [ROUTES.ANNUAL_PAYMENT_LIST]: {
    path: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${ROUTES.ANNUAL_PAYMENT_LIST}`,
    permissionKey: ROUTES.ANNUAL_PAYMENT_LIST,
    usageKey: "salary_management",
  },
  [ROUTES.PROJECT_MANAGE]: {
    path: `/${ROUTES.PROJECT_CHART}`,
    permissionKey: ROUTES.PROJECT_MANAGE,
    usageKey: "project_management",
  },
  [ROUTES.PROJECT_MANAGER_LIST]: {
    path: `/${ROUTES.PROJECT_MANAGER_LIST}`,
    permissionKey: ROUTES.PROJECT_MANAGE,
    usageKey: "project_management",
  },
  [ROUTES.KPI]: {
    path: `/${ROUTES.KPI}`,
    permissionKey: ROUTES.KPI,
    usageKey: "actual_kpi",
  },
};
